import initWordPress from './initWordPress';
import checkIfWordPress from './checkIfWordPress';
import getLeadinConfig from './getLeadinConfig';
import buildWordpressUrl from './buildWordpressUrl';
import CheckIfIntegratedApp from './checkIfIntegratedApp';
const isWordPress = checkIfWordPress();
const isIntegratedFormsApp = CheckIfIntegratedApp.isIntegratedFormsApp;

const isWordPressAdmin = () => getLeadinConfig().admin;

export { initWordPress, isWordPress, isWordPressAdmin, buildWordpressUrl, isIntegratedFormsApp };